import React from "react";
import engImage from '../images/engg.jpeg';
import FaIcon from '../utils/FaIcon';


const ChooseUs = () => (
    <div className='transparent-card-wrapper'>
        <div className='transparent-card left-card'>
            <img src={engImage} alt="Engineering illustration" className='eng-image' />
        </div>
        <div className='transparent-card right-card'>
            <h3 style={{ color: "#e47931" }}>What makes us the right choice</h3>
            <h1>Your Trusted Partner for Industrial Solutions</h1>
            <p>Choosing the right manufacturer for Cable Trays is essential to not only meet but exceed your expectations.</p>
            <ul>
                <li>
                    <div className='list-bullet'><FaIcon icon="list-check" color={'#e47931'} /></div>
                    <span>Our Dedication to Delivering Excellence ensures Quality</span>
                    <p>
                        We are committed to delivering high-quality products and services. Our team ensures every product meets stringent quality standards, providing you with reliability and peace of mind.
                    </p>
                </li>
                <li>
                    <div className='list-bullet'><FaIcon icon="person-circle-check" color={'#e47931'} /></div>
                    <span>We are Customer-Centric, Putting Your Needs First!</span>
                    <p>
                        We prioritize our customers, working closely with you to understand your requirements. Our dedicated support team is always ready to assist, ensuring a seamless experience from start to finish.
                    </p>
                </li>

                <li>
                    <div className='list-bullet'><FaIcon icon="plug-circle-check" color={'#e47931'} /></div>
                    <span>Customized Industry Solutions Just for You</span>
                    <p>
                        We offer a wide range of solutions customized for various industries, including manufacturing, construction, and more. Our expertise allows us to deliver personalized solutions that address your unique needs.
                    </p>
                </li>
            </ul>
        </div>
    </div>



);

export default ChooseUs;